// Generated from SVG to Code Figma Plugin

export const ProductLineReference = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M20.3996 11.3997L20.3996 6.59971C20.3996 5.27422 19.3251 4.19971 17.9996 4.19971H5.99961C4.67413 4.19971 3.59961 5.27422 3.59961 6.59971V17.3997C3.59961 18.7252 4.67413 19.7997 5.99961 19.7997L12.5996 19.7997"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="1.5"
    />
    <path
      d="M14.3996 11.9999L10.7996 14.0784V9.92144L14.3996 11.9999Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.2"
    />
    <path
      d="M16.3389 14.7331C16.5442 14.3775 17.0574 14.3775 17.2627 14.7331L18.071 16.1331C18.2762 16.4887 18.0196 16.9331 17.6091 16.9331H15.9925C15.5819 16.9331 15.3253 16.4887 15.5306 16.1331L16.3389 14.7331Z"
      fill="currentColor"
    />
    <rect height="2.4" width="2.4" fill="currentColor" rx="0.533333" x="19.334" y="17.9995" />
    <circle cx="16.7999" cy="19.1998" fill="currentColor" r="1.26667" />
    <circle cx="20.5323" cy="15.733" fill="currentColor" r="1.26667" />
  </svg>
);
